<template>
  <div class="backdrop-xl" @keydown.esc="attemptClose" @click="attemptClose">
    <div class="container">
      <div class="modal-container-xl">
        <light-close-button @click="abort" v-if="closeable"/>
        <div class="modal-wrapper">
          <div class="body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LightCloseButton from "./LightCloseButton";

export default {
  props: {
    closeable: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  methods: {
    attemptClose() {
      if (this.closeable) {
        this.abort()
      }
    },
    abort () {
      this.$emit('abort')
    }
  },
  components: {
    // OutlineButton,
    // Logo,
    LightCloseButton,
  }
}
</script>

<style scoped lang="scss">

.backdrop-xl {
    background: rgba(0, 0, 0, 0.8);
    align-items: flex-start;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 9000;

    &.no-padding > .modal-container > .modal-wrapper > .content-wrapper {
      padding: 0;
    }
  }

  .container {
    padding: 0;
  }

  .modal-container-xl {
    margin: 30px 30px;
    max-width: 100%;
    padding: 0;
    background-color: $body-bg;
    display: flex;
    position: relative;
    background-color: #f5f2f0;
    padding-bottom: 16px;
    @media screen and (max-width: 750px) {
      margin-top: 50px;
    }


    .content-wrapper {
      padding: 30px 30px 15px;
      @media screen and (max-width: 750px) {
        padding: 20px 20px 5px;
        h3 {
          margin-right: 30px;
        }
      }
    }

    .abort-wrapper {
      text-align: center;
    }


    &.dark {

      background-color: $dark-bg;
      .grey-block {
        padding: 0 30px 15px;
      }
      @media screen and (max-width: 769px) {
        display: block;
        .text-wrapper {
          padding-left: 30px;
          padding-right: 30px;
        }
        padding-bottom: 50px;
      }
    }
  }
  .modal-wrapper {
    flex: 1;
  }
</style>
